import { MutableRefObject, createRef } from 'react';

import { StoresContextType } from './stores.types';

export const storesMapContextInitialValue: StoresContextType = {
  getters: {
    storeCandidate: undefined,
    isChangeStoreConfirmationModalOpen: false,
    isFetchingStores: false,
    isOnlineRetailer: false,
    stores: [],
    // Stub ref for the context default value (never used at runtime because
    // useStoresContext throws when called outside a provider).
    lastReconciledStoreIdRef: createRef<
      number | undefined
    >() as MutableRefObject<number | undefined>,
  },
  handlers: {
    cancelStoreChange: () => null,
    confirmStoreChange: () => null,
    handleStoreSelection: () => () => null,
  },
};
